/**
 * WebGLのウォークポイントのコンテナを作るファイル
 */

import { Group } from "three";

import NodeIcon from "@/webgl/room/NodeIcon";

export default class NodeIconContainer extends Group {
  constructor() {
    super();

    this.nodes = []; // ウォークポイントを格納する配列
    this.edge = []; // ウォークポイントの接続情報を格納する配列
  }

  init() {
    this.nodes = [];
    this.edge = [];
  }

  /**
   * @param {*} data - APIのwalk_through（参照: https://github.com/lifull/ai-madori-webviewer/wiki/API#1-1-%E5%BA%A7%E6%A8%99%E6%83%85%E5%A0%B1）
   */
  set(data) {
    for (let i = 0; i < data.node.length; i++) {
      const node = new NodeIcon(data.node[i]);
      this.nodes.push(node);
      this.add(node);
    }

    this.edge = data.edge;

    const startId = data.start;
    let startIndex = 0;
    for (let i = 0; i < data.node.length; i++) {
      if (data.node[i].node_id === startId) {
        startIndex = i;
      }
    }
    // startIndexのウォークポイントのnext_idがnullの場合、startIndexを0にする
    if (data.node[startIndex].next_id === null) {
      startIndex = 0;
    }
    this.changeNodeDisplay(startIndex);
  }

  /**
   * ウォークポイントの表示切り替え
   * カレントのウォークポイントと接続しているウォークポイントだけを表示する
   */
  changeNodeDisplay(id) {
    // init
    for (let i = 0; i < this.nodes.length; i++) {
      this.nodes[i].off(false);
    }

    for (let i = 0; i < this.edge.length; i++) {
      const edge = this.edge[i];
      if (edge[0] === id) {
        const node = this.getNode(edge[1]);
        if (node !== null) {
          node.on(true);
        }
      } else if (edge[1] === id) {
        const node = this.getNode(edge[0]);
        if (node !== null) {
          node.on(true);
        }
      }
    }
  }

  /**
   * node_idからNodeを取得する
   * @param {*} edge
   * @returns Node
   */
  getNode(edge) {
    for (let i = 0; i < this.nodes.length; i++) {
      if (edge === this.nodes[i].node_id) {
        return this.nodes[i];
      }
    }
    return null;
  }
}
